module.exports = __webpack_public_path__ + "img/school8.83471a6c.png";